/**
 * Paths the service worker may keep. Authenticated API responses are excluded.
 * Cache keys are plain URLs, so an Authorization header is never stored.
 */
export function isAuthenticatedApiPath(pathname: string): boolean {
  return pathname === '/api' || pathname.startsWith('/api/');
}

export function mayStoreInCache(url: string): boolean {
  try {
    const pathname = new URL(url, 'http://localhost').pathname;
    return !isAuthenticatedApiPath(pathname);
  } catch {
    return false;
  }
}

/** App shell documents. Explicit downloads are added later and still pass mayStoreInCache. */
export function shellCacheList(): string[] {
  return ['/', '/index.html', '/manifest.webmanifest', '/icons/abacus-192.png', '/icons/abacus-512.png'];
}

export function cacheListExcludesAuthenticatedApis(urls: string[]): boolean {
  return urls.every((url) => {
    const pathname = url.startsWith('/') ? url : new URL(url, 'http://localhost').pathname;
    return !isAuthenticatedApiPath(pathname);
  });
}
